import PropTypes from "prop-types";

const MediaCardStyleOne = ({
	mediaType,
	title,
	description,
	thumbnailUrl,
	mediaSinglePageUrl,
	lightboxGroupName,
	createdDate,
	mediaUrl,
	isSinglePageImage,
}) => {
	const renderMediaTypeIcon = () => {
		const assetsPath = wpApiSettings.bseit_assets_dir_url + "icons/";
		const iconClasses =
			"absolute z-50 w-10 h-10 top-1 left-1 rtl:left-auto rtl:right-1";
		switch (mediaType) {
			case "image":
				return (
					<img
						src={`${assetsPath}image-file.png`}
						alt="image-icon"
						loading="lazy"
					/>
				);
			case "image_group":
				return (
					<img
						src={`${assetsPath}image-file.png`}
						alt="image-icon"
						loading="lazy"
					/>
				);
			case "video":
				return <i className="text-white fa-solid fa-play"></i>;
			case "audio":
				return (
					<img
						src={`${assetsPath}audio-file.png`}
						alt="audio-icon"
						loading="lazy"
					/>
				);
			case "pdf":
				return (
					<img
						src={`${assetsPath}pdf-file.png`}
						alt="pdf-icon"
						loading="lazy"
					/>
				);
			default:
				return <p>Unsupported media type</p>;
		}
	};
	if (mediaType === "image_group") {
		if (isSinglePageImage) {
			return (
				<a
					href={mediaUrl}
					data-fancybox={"gallery-" + lightboxGroupName}
					data-caption={description}
					className="flex overflow-hidden relative flex-col justify-start items-start p-4 w-full rounded-lg shadow-lg bg-lightGray media-card group min-h-80"
				>
					<p className="text-darkGray">{createdDate}</p>

					<div className="w-full h-40 xl:h-52 relative rounded-[10px] overflow-hidden my-4">
						<img
							alt={title}
							src={thumbnailUrl}
							className="absolute inset-0 object-cover w-full h-full transition-all rounded-[10px]"
							loading="lazy"
						/>
						<div className="w-full h-full left-0 top-0 absolute hidden group-hover:flex items-center justify-center bg-black/50 rounded-[10px]">
							<div className="w-6 h-6">{renderMediaTypeIcon()}</div>
						</div>
					</div>

					<h3 className="mb-2 font-semibold line-clamp-3 text-primary media-title">
						{title}
					</h3>
				</a>
			);
		} else {
			return (
				<a
					href={mediaSinglePageUrl}
					className="flex overflow-hidden relative flex-col justify-start items-start p-4 w-full rounded-lg shadow-lg bg-lightGray media-card group min-h-80"
				>
					<p className="text-darkGray">{createdDate}</p>

					<div className="w-full h-40 xl:h-52 relative rounded-[10px] overflow-hidden my-4">
						<img
							alt={title}
							src={thumbnailUrl}
							className="absolute inset-0 object-cover w-full h-full transition-all rounded-[10px]"
							loading="lazy"
						/>
						<div className="w-full h-full left-0 top-0 absolute hidden group-hover:flex items-center justify-center bg-black/50 rounded-[10px]">
							<div className="w-6 h-6">{renderMediaTypeIcon()}</div>
						</div>
					</div>

					<h3 className="mb-2 font-semibold line-clamp-3 text-primary media-title">
						{title}
					</h3>
				</a>
			);
		}
	} else {
		return (
			<a
				href={mediaUrl}
				data-fancybox={"gallery-" + lightboxGroupName}
				data-caption={description}
				className="flex overflow-hidden relative flex-col justify-start items-start p-4 w-full rounded-lg shadow-lg bg-lightGray media-card group min-h-80"
			>
				<p className="text-darkGray">{createdDate}</p>

				<div className="w-full h-40 xl:h-52 relative rounded-[10px] overflow-hidden my-4">
					<img
						alt={title}
						src={thumbnailUrl}
						className="absolute inset-0 object-cover w-full h-full transition-all rounded-[10px]"
						loading="lazy"
					/>
					<div className="w-full h-full left-0 top-0 absolute hidden group-hover:flex items-center justify-center bg-black/50 rounded-[10px]">
						<div className="w-6 h-6">{renderMediaTypeIcon()}</div>
					</div>
				</div>

				<h3 className="mb-2 font-semibold line-clamp-3 text-primary media-title">
					{title}
				</h3>
			</a>
		);
	}
};

MediaCardStyleOne.propTypes = {
	mediaType: PropTypes.oneOf(["image", "image_group", "video", "audio", "pdf"]),
	title: PropTypes.string,
	description: PropTypes.string,
	thumbnailUrl: PropTypes.string,
	mediaUrl: PropTypes.string,
	lightboxGroupName: PropTypes.string,
	createdDate: PropTypes.string,
};

export default MediaCardStyleOne;
